export const buildGoliathImagePath = (mediaId, size, type) => `/product-images/${mediaId}/thumbnail_${type}/thumbnail_${size}.${type}`;
// Helper function to process a media item
export const processMediaItem = (image, type = "webp") => {
    if (!image)
        return undefined;
    if (image.remote) {
        if (!image.url)
            return undefined;
        return {
            name: image.name || undefined,
            url: image.url,
            remote: true,
        };
    }
    else {
        const localImage = image;
        if (!localImage.mediaId)
            return undefined;
        return {
            name: image.name || undefined,
            mediaId: localImage.mediaId,
            small: buildGoliathImagePath(localImage.mediaId, 250, type),
            medium: buildGoliathImagePath(localImage.mediaId, 500, type),
            large: buildGoliathImagePath(localImage.mediaId, 1000, type),
            remote: false,
        };
    }
};
export const getGoliathImagesWithRemote = (offer, type = "webp") => {
    const teaserImage = offer.teaserImage ||
        offer.product?.teaserImage ||
        ("scopedProduct" in offer
            ? offer.scopedProduct?.teaserImage || undefined
            : undefined) ||
        undefined;
    if ((!offer.media || !Array.isArray(offer.media)) && !teaserImage)
        return [];
    const images = [];
    // Process media items if available
    if (Array.isArray(offer.media)) {
        offer.media
            .filter((m) => m?.type === "IMAGE")
            .forEach((m) => {
            const img = processMediaItem(m, type);
            if (!img)
                return;
            images.push(img);
        });
    }
    // If no media items are found, use teaserImage if available
    if (images.length === 0 && teaserImage) {
        const img = processMediaItem(teaserImage, type);
        if (img) {
            images.push(img);
        }
    }
    return images;
};
export const getGoliathImages = (offer, type = "webp") => {
    const images = getGoliathImagesWithRemote(offer, type);
    return images.filter((image) => !image.remote);
};
export const getGoliathImage = (offer, type = "webp") => {
    const images = getGoliathImagesWithRemote(offer, type);
    return images.find((image) => !image.remote);
};
